import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { EventProvider } from '../../providers/event/event';
import { SessionProvider } from '../../providers/session/session';
import { UserProvider } from '../../providers/user/user';


@Component({
	selector: 'participant-list-component',
	templateUrl: 'participant-list.html'
})
export class ParticipantListComponent {
	searchTxt: string = "";
	autoCompleteTimer?: any = null;;
	autoCompleteList: any[] = [];

	activeItem: any;
	email: any = "";

	constructor(private viewCtrl: ViewController,
		private toastCtrl: ToastController,
		private navParams: NavParams,
		private userService: UserProvider,
		private eventService: EventProvider,
		private translate: TranslateService,
		private sessionService: SessionProvider) {
	}

	onParticipantSelect(participant) {
		this.viewCtrl.dismiss(participant);
	}

	onClose() {
		this.viewCtrl.dismiss(null);
	}

	invite() {
		this.sessionService.getToken().then(token => {
			let lang = this.translate.getDefaultLang();
			this.eventService.invite(token, this.email, lang).then((result) => {
				console.log('result: ', result);
				if (result) {
				this.showToast(this.translate.instant('FRIEND_IS_INVITED_MSG'));
				}
			});
		});
	}



	showToast(message) {
		let toast = this.toastCtrl.create({
			message: message,
			duration: 5000,
			position: 'top'
		});
		toast.present();
	}

	autocompleteKeyUp(event) {
		if (this.autoCompleteTimer) {
			clearInterval(this.autoCompleteTimer);
			this.autoCompleteTimer = null;
		}
		if (event.target.value == null) {
			return;
		}
		if (event.target.value.length > 2) {
			this.autoCompleteTimer = setTimeout(() => {
				this.eventService.searchRouteParticipant(event.target.value).then((values) => {
					this.autoCompleteList = values;
					// this.autoCompleteList = this.autoCompleteList.filter(x => this.activeItem.participants.find(y => y.lid === x.lid) ? false : true)
				});
			}, 400)
		} else {
			this.autoCompleteList = [];
		}
	}

}



// WEBPACK FOOTER //
// /src/components/participant-list/participant-list.ts